var ExtJSON = require('./lib/ext_json');

module.exports = ExtJSON;



// WEBPACK FOOTER //
// ./~/mongodb-extjson/index.js